import React from "react";
import PropTypes from "prop-types";
import CoreScrollSelector from "./../CoreScrollSelector";
import { ArtsFoundationHeroLandingDiv } from "./elements";

const ArtsFoundationHeroLanding = ({
  title,
  menuItems,
  returnLink,
  selected,
  selection,
  backgroundColor
}) => (
  <ArtsFoundationHeroLandingDiv backgroundColor={backgroundColor}>
    <CoreScrollSelector
      menuItems={menuItems}
      returnLink={returnLink}
      selectedMode={selected ? true : false}
      selection={selection}
      
    />
    <div>
      <h1>{title}</h1>
    </div>
  </ArtsFoundationHeroLandingDiv>
);

export default ArtsFoundationHeroLanding;

ArtsFoundationHeroLanding.propTypes = {
  title: PropTypes.node,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.node,
      link: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  returnLink: PropTypes.func,
};
